import { render, staticRenderFns } from "./ColumnSettings.vue?vue&type=template&id=8b6534bc&scoped=true&"
import script from "./ColumnSettings.vue?vue&type=script&lang=js&"
export * from "./ColumnSettings.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSettings.vue?vue&type=style&index=0&id=8b6534bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6534bc",
  null
  
)

export default component.exports